export function getCulture() {
	return document.documentElement.getAttribute('data-lang') || document.documentElement.getAttribute('lang') || 'en-US';
}

export function getCurrency() {
	return document.documentElement.getAttribute('data-currency') || 'USD';
}

export function getCurrencySymbol() {
	return document.documentElement.getAttribute('data-currency-symbol') || '$';
}

export function getMarketId() {
	return document.documentElement.getAttribute('data-market-id') || 'DK';
}

export function getPageId() {
	return document.documentElement.getAttribute('data-page-id') || ''
}


